import { ExperimentList } from './ExperimentList'
import { NewExperiment } from './NewExperiment'
import style from './style.module.scss'

interface Props {
  items: any[]
}

export const Experiments = ({ items }: Props) => {
  return (
    <div className={style.experiment}>
      <div className={style.actions}>
        <NewExperiment />
      </div>
      <div className={style.content}>
        <ExperimentList items={items} />
      </div>
    </div>
  )
}
